






















import Vue from 'vue'
interface BreadcrumbItem {
  target: string;
  label: string;
}

export default Vue.extend({
  name: 'PageTitle',
  computed: {
    showBreadCrumbs (): boolean {
      if (!this || !this.$route || !this.$route.meta) {
        return false
      }
      return this.$route.meta.showBreadCrumbs || false
    },
    pageTitle (): string {
      let title = ''
      if (!this || !this.$route || !this.$route.meta) {
        return ''
      }
      if (this.$route.meta.pageTitle && this.$route.meta.pageTitle.label) {
        title += this.$t('navigation.' + this.$route.meta.pageTitle.label).toString()
      }
      if (this.$route.meta.pageTitle && this.$route.meta.pageTitle.params) {
        if (title !== '') {
          title += ': '
        }
        title += this.$route.params[this.$route.meta.pageTitle.params]
      }
      return title !== '' ? title : 'CORPU'
    },
    breadcrumbs (): BreadcrumbItem[] {
      if (!this || !this.$route || !this.$route.meta) {
        return []
      }
      if (!this.$route.meta.breadcrumbs) {
        return []
      }
      return this.$route.meta.breadcrumbs
    }
  }
})
